import StoresList from '../components/StoresList';
import FixLoading from '../layout/FixLoading';

const StoresPage = () => {
    return (
        <FixLoading>
            <StoresList />
        </FixLoading>
    );
};

export default StoresPage;
